<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请人">
              <global-select
                :value.sync="queryParams.applicantList"
                requestApi="/inv/invCallRequestLines/applicantBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="叫料单号">
              <a-input v-model="queryParams.callDocNumberVal" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工单号">
              <a-input v-model="queryParams.wipEntityNameVal" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                :value.sync="queryParams.organizationCodeListNew"
                selectType="selectAssembleMultiple"
                :selectData="inventOrgList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :assembleLabel="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="物料类别">
              <a-tree-select
                v-model="queryParams.categoryIdList"
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.itemIdList"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="itemCode"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="物料类型">
              <global-select
                :value.sync="queryParams.itemTypeList"
                selectType="selectMultipleSearch"
                requestApi="/system/lookup/data/likeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'MDM_ITEM_TYPE' }"
                searchParam="lookupValue"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="零部件类型">
              <global-select
                :value.sync="queryParams.componentTypeList"
                selectType="selectMultipleSearch"
                requestApi="/system/lookup/data/likeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'MES_ITEM_ZCBCP_TYPE' }"
                searchParam="lookupValue"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="备料分类">
              <global-select
                :value.sync="queryParams.deliveryType"
                selectType="select"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'MDM_DELIVERY_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="来源">
              <global-select
                :value.sync="queryParams.sourceCodeList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'INV_CALL_DOC_SOURCE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="类型">
              <global-select
                :value.sync="queryParams.orderTypeList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'INV_CALL_DOC_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="创建日期">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.createTimeList, 'YYYY-MM-DD') }}</template>
                <a-range-picker v-model="queryParams.createTimeList" allowClear />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="要求到货时间" :labelCol="{ style: { width: '90px' } }">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.demandDate) }}</template>
                <a-range-picker
                  v-model="queryParams.demandDate"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  :show-time="{ defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.statusList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'INV_CALL_DOC_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="仅查询有退货的未结单据" :labelCol="{ style: { width: '160px' } }">
              <a-switch :checked="queryParams.switchFlg === 'Y'" @change="statusOnChange" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="工单叫料版本号" :labelCol="{ style: { width: '120px' } }">
              <global-select
                ref="refVersion"
                :value.sync="queryParams.versionList"
                selectType="selectMultipleSearch"
                searchParam="version"
                requestApi="/inv/invCallRequestLines/versionComboBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <!--          <a-col :md="6" :sm="24" v-if="advanced">-->
          <!--            <a-form-item label="库存情况" :labelCol="{ style: { width: '90px' } }">-->
          <!--              <a-select v-model="queryParams.inventorySituation">-->
          <!--                <a-select-option key="1" value="库存满足">库存满足</a-select-option>-->
          <!--                <a-select-option key="2" value="库存不足">库存不足</a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划单号">
              <a-input v-model="queryParams.orderNo" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="出库订单">
              <a-input v-model="queryParams.deliveryOrder" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="接收方入库单">
              <a-input v-model="queryParams.asnOrder" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(queryParams)">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiInvCallRequestLinesExport" ref="download" />
      <a-button type="primary" @click="goDetail('add')">新建</a-button>
      <a-button @click="handleExport" v-hasPermi="['scp:invCallRequestLines:export']">导出</a-button>
      <a-button type="primary" :disabled="selectedRows.length<1" :loading="btnLoading" @click="onPrintCallMaterial">打印叫料单</a-button>
      <a-button ref="printCallMaterialBtn" v-show="false" v-print="'#printCallMaterialId'">打印叫料单</a-button>
      <a-button ref="hardwarePrintCallMaterialBtn" v-show="false" v-print="'#hardwarePrintCallMaterialId'">五金箱打印叫料单</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @change="handleTableChange"
          @selectedRowChange="selectedRowChange"
          rowKey="id"
          :scroll="{ x: tableX, fixScreen: true }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.CALL_MATERIAL_MANAGE_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a @click="goDetail('edit', record)" v-hasPermi="['scp:invCallRequestLines:obtainEditingData']">编辑</a>
                <a @click="handleCancel(record)" class="ml10" v-hasPermi="['scp:invCallRequestLines:cancellation']">取消</a>
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk" />
        <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
      </div>
      <div class="display-none" v-if="showPrint">
        <printCallMaterial ref="printCallMaterialRef" id="printCallMaterialId" />
        <hardwareCallMaterialPrint ref="hardwareCallMaterialPrintRef" id="hardwarePrintCallMaterialId" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiInvCallRequestLinesList,
  apiScpMrpCategoryCodeCategoryBox,
  apiInvCallRequestLinesExport,
  apiScpScreeningSchemeSearchAllScheme,
  apiInvCallRequestLinesCancellation,
  apiPrintCallNoticeBatch,
  apiPrintWjCallBatch
} from '@/api/scp/factoryCallMaterial/callMaterialManage'
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import { generateLsTableResData, handleCopyFromExcel } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import printCallMaterial from './components/print-call-material'
import hardwareCallMaterialPrint from './components/hardware-call-material-print.vue'
export default {
  name: 'CallMaterialManage',
  components: {
    DownloadModal,
    DressingByScreening,
    hardwareCallMaterialPrint,
    DressingByScreeningSetUp,
    printCallMaterial
  },
  data () {
    return {
      apiInvCallRequestLinesExport,
      isEdit: false,
      currentId: "",
      showPrint: false,
      btnLoading: false,
      tableProps: {
        requestApi: generateLsTableResData(apiInvCallRequestLinesList, true),
        pageCurrent: true
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 查询参数
      queryParams: {
        applicantList: undefined,
        callDocNumberVal: undefined,
        wipEntityNameVal: undefined,
        organizationCodeListNew: [],
        organizationCodeList: undefined,
        categoryIdList: undefined,
        itemIdList: undefined,
        sourceCodeList: undefined,
        orderTypeList: undefined,
        // inventorySituation: undefined,
        orderNo: undefined,
        createTimeList: undefined,
        staCreateTime: undefined,
        endCreateTime: undefined,
        switchFlg: undefined,
        statusList: undefined,
        demandDate: undefined,
        deliveryType: undefined,
        versionList: []
      },
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 4500,
      tableList: [],
      // 表格字段
      columns: [
        { title: '组织', dataIndex: 'organizationName', align: 'center', width: 115, stickyFixed: 'left' },
        { title: '叫料单号', dataIndex: 'callDocNumber', align: 'center', width: 140, stickyFixed: 'left' },
        { title: '行号', dataIndex: 'lineNumber', align: 'center', stickyFixed: 'left', width: 50, ellipsis: true },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 120, stickyFixed: 'left' },
        { title: '类型', dataIndex: 'itemTypeName', align: 'center', width: 75, stickyFixed: 'left', ellipsis: true },
        { title: '备料分类', dataIndex: 'deliveryTypeName', align: 'center', width: 80, stickyFixed: 'left', ellipsis: true },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 100, stickyFixed: 'left', ellipsis: true },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 140, ellipsis: true },
        { title: '单位', dataIndex: 'uom', align: 'center', width: 55 },
        { title: 'MPQ', dataIndex: 'fixedLotMultiplier', width: 80, align: 'center' },
        { title: '工单号', dataIndex: 'wipEntityName', align: 'center', width: 130 },
        { title: '计划单号', dataIndex: 'orderNo', align: 'center', width: 120 },
        {
          title: '要求到货时间',
          dataIndex: 'demandDate',
          scopedSlots: { customRender: 'demandDate' },
          align: 'center',
          width: 150,
          sorter: true,
          type: "text"
        },
        { title: '需求量', dataIndex: 'demandQty', width: 60, align: 'center' },
        { title: '已发货', dataIndex: 'shipmentQuantity', width: 60, align: 'center' },
        { title: '接收数量', dataIndex: 'receivedQuantity', width: 70, align: 'center' },
        { title: '已退货', dataIndex: 'returnedQuantity', width: 60, align: 'center' },
        { title: '已退货接收', dataIndex: 'returnReceiveQuantity', width: 90, align: 'center' },
        { title: '取消数量', dataIndex: 'canceledQuantity', width: 70, align: 'center' },
        { title: '供应组织', dataIndex: 'supplyOrganizationName', width: 100, align: 'center' },
        { title: '供应商', dataIndex: 'supplierName', align: 'center', width: 120, ellipsis: true },
        { title: '零部件工单', dataIndex: 'supplyWipEntityName', align: 'center', width: 130 },
        { title: '状态', dataIndex: 'statusName', align: 'center', width: 90 },
        { title: '类型', dataIndex: 'orderTypeName', align: 'center', width: 90 },
        { title: '批次', dataIndex: 'lotNumber', align: 'center', width: 100 },
        { title: '色号&色差', dataIndex: 'colorNumDiff', width: 120, align: 'center' },
        { title: '备注', dataIndex: 'comment', align: 'center', width: 120 },
        {
          title: '最早发货时间',
          dataIndex: 'earliestDeliveryDate',
          scopedSlots: { customRender: 'earliestDeliveryDate' },
          align: 'center',
          width: 150,
          type: "text"
        },
        {
          title: '最后接收时间',
          dataIndex: 'latestReceivingDate',
          scopedSlots: { customRender: 'latestReceivingDate' },
          align: 'center',
          width: 150,
          type: "text"
        },
        { title: '到货状态', dataIndex: 'arrivalStatus', width: 80, align: 'center' },
        { title: '来源', dataIndex: 'sourceCodeName', width: 100, align: 'center' },
        { title: '更新人', dataIndex: 'updateName', width: 80, align: 'center' },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          align: 'center',
          width: 140,
          type: "text"
        },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 80 },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
          width: 140,
          type: "text"
        },
        { title: '工单叫料版本号', dataIndex: 'version', width: 120, align: 'center' },
        // { title: '库存情况', dataIndex: 'inventorySituation', width: 140, align: 'center' },
        { title: '同步情况', dataIndex: 'errorMsg', width: 180, align: 'center', ellipsis: true },
        { title: '出库订单', dataIndex: 'deliveryOrder', width: 100, align: 'center' },
        { title: '出库组织编码', dataIndex: 'outOrganizationCode', width: 100, align: 'center' },
        { title: '出库子库', dataIndex: 'outSubLibrary', width: 100, align: 'center' },
        { title: '接收方入库单', dataIndex: 'asnOrder', width: 120, align: 'center' },
        { title: '入库组织编码', dataIndex: 'inOrganizationCode', width: 100, align: 'center' },
        { title: '入库子库', dataIndex: 'inSubLibrary', width: 100, align: 'center' },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      searchList1: [],
      searchList2: [],
      treeData: [], // 物料类别
      inventOrgList: [] // 组织
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  watch: {
    "queryParams.createTimeList" (newVal, oldVal) {
      this.queryParams.staCreateTime = newVal[0] && `${this.$moment(newVal[0]).format('YYYY-MM-DD')} 00:00:00`
      this.queryParams.endCreateTime = newVal[1] && `${this.$moment(newVal[1]).format('YYYY-MM-DD')} 23:59:59`
      this.$refs.dataTable.searchParams = this.queryParams;
    }
  },
  created () {
    this.getCategoryIdList(true)
    this.getSearchAllScheme()
    // 组织下拉框去除选项中的库存组织四个字
    const arr = JSON.parse(JSON.stringify(this.inventOrg))
    arr.forEach(element => {
      const num = element.label.indexOf("库存组织")
      if (num > 0) {
        element.label = element.label.substring(0, num)
      }
    });
    this.inventOrgList = arr
  },
  mounted () {
    this.onSearch()
    if(this.$route?.query?.callDocNumber) {
      setTimeout(() => {
        // 当跳转的type 为 WJCK或XWJCK 时，打印五金箱叫料单
        if(this.$route?.query?.type === 'WJCK' || this.$route?.query?.type === 'XWJCK') {
          this.batchHardwarePrintCallMaterial([{ callDocNumber: this.$route.query.callDocNumber }])
          return
        }
        this.batchPrintCallMaterial([{ callDocNumber: this.$route.query.callDocNumber }]) // 打印叫料单（用于处理wms跳转过来的打印）
      }, 100)
    }
  },
  methods: {
    // table排序等
    handleTableChange (pagination, filters, sorter, { currentDataSource }) {
      let obj = {}
      const params = this.$refs.dataTable.searchParams
      if(sorter?.order && sorter?.columnKey) {
        obj = {
          orderColumn: sorter.columnKey,
          sortFlag: sorter.order === "ascend" ? 'asc' : 'desc'
        }
        this.$refs.dataTable.searchParams = cloneDeep({ ...params, ...obj });
      } else {
        if (params?.orderColumn) {
          delete params.orderColumn
          delete params.sortFlag
          this.$refs.dataTable.searchParams = params
        }
      }
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 新增/修改框事件
    handleOk () {
      this.getCategoryIdList()
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    // 打印叫料单
    onPrintCallMaterial() {
      if (this.selectedRows?.length < 1) {
        this.$message.warning("请勾选单据")
        return
      }
      // 后端说只能用描述判断，没有编码
      const getWjx = this.selectedRows.filter(item => item.itemTypeName === '五金箱')
      if(getWjx?.length > 0 && getWjx.length !== this.selectedRows.length) {
        this.$message.warning("类型为五金箱的要单独打印，请重新选择")
        return
      }
      if(getWjx.length > 0) {
        this.batchHardwarePrintCallMaterial(this.selectedRows)
      } else {
        this.batchPrintCallMaterial(this.selectedRows)
      }
    },
    // 批量打印参数（去重）
    getPrintParams(data) {
      const seen = new Set()
      const params = data.filter(item => {
        if (seen.has(item.callDocNumber)) {
          return false
        }
        seen.add(item.callDocNumber)
        return true
      }).map(item => {
        return {
          callDocNumber: item.callDocNumber
        }
      })
      return params
    },
    // 叫料批量打印
    batchPrintCallMaterial(data) {
      this.showPrint = false
      const params = this.getPrintParams(data);
      this.btnLoading = true;
      this.$message.loading('正在打印中，请稍等..', 2);
      apiPrintCallNoticeBatch(params).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.showPrint = true
          setTimeout(() => {
            this.$refs.printCallMaterialRef.show(res.data)
            this.$refs.printCallMaterialBtn.$el.dispatchEvent(new MouseEvent("click"))
          }, 300)
        } else {
          this.$message.warning("无打印数据！")
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 五金箱叫料批量打印
    batchHardwarePrintCallMaterial(data) {
      this.showPrint = false
      const params = this.getPrintParams(data);
      this.btnLoading = true
      this.$message.loading('正在打印中，请稍等..', 2);
      apiPrintWjCallBatch(params).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.showPrint = true
          setTimeout(() => {
            this.$refs.hardwareCallMaterialPrintRef.show(res.data)
            this.$refs.hardwarePrintCallMaterialBtn.$el.dispatchEvent(new MouseEvent("click"))
          }, 300)
        } else {
          this.$message.warning("无打印数据！")
        }
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 表单搜索
    onSearch () {
      if (!this.queryParams?.organizationCodeListNew || this.queryParams?.organizationCodeListNew?.length < 1) {
        const arr = []
        this.inventOrg.forEach(element => {
          arr.push(element.realValue)
        });
        this.queryParams.organizationCodeList = arr
      } else {
        this.queryParams.organizationCodeList = this.queryParams.organizationCodeListNew
      }
      const obj = JSON.parse(JSON.stringify(this.queryParams))
      obj.staDemandDate = obj.demandDate && obj.demandDate[0] || ""
      obj.endDemandDate = obj.demandDate && obj.demandDate[1] || ""
      delete obj.demandDate
      delete obj.createTimeList
      if (this.queryParams?.applicantList) obj.applicantList = cloneDeep([this.queryParams.applicantList]) // 申请人用数组入参
      // 排序
      const historyParams = this.$refs.dataTable.searchParams
      if (historyParams?.orderColumn) { obj.orderColumn = historyParams.orderColumn }
      if (historyParams?.sortFlag) { obj.sortFlag = historyParams.sortFlag }
      handleCopyFromExcel('callDocNumber', 'callDocNumberList', obj) // 物料编码支持excel的copy查询
      handleCopyFromExcel('wipEntityName', 'wipEntityNameList', obj)
      this.$refs.dataTable.searchParams = obj;
      this.$refs.dataTable.getData();
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.queryParams = JSON.parse(val.schemeDetailJson)
      this.onSearch()
    },
    // 跳转详情
    goDetail (val, record) {
      if (val === "edit" && record.status !== "NEW") {
        this.$message.warning("只有新建状态才能获取编辑详情")
        return
      }
      this.$router.push({ name: `call-material-manage-detail`, query: { status: val, data: JSON.stringify(record) } })
    },
    // 取消
    handleCancel (record) {
      const self = this
      this.$confirm({
        title: '你确定要取消这行内容吗?',
        content: "",
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiInvCallRequestLinesCancellation(record.id).then(response => {
            if (response.code === 200) {
              self.$message.success('取消成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        applicantList: undefined,
        callDocNumberVal: undefined,
        wipEntityNameVal: undefined,
        organizationCodeListNew: [],
        // inventorySituation: undefined,
        orderNo: undefined,
        organizationCodeList: undefined,
        categoryIdList: undefined,
        itemIdList: undefined,
        sourceCodeList: undefined,
        orderTypeList: undefined,
        createTimeList: undefined,
        staCreateTime: undefined,
        endCreateTime: undefined,
        switchFlg: undefined,
        statusList: undefined,
        demandDate: undefined,
        deliveryType: undefined,
        versionList: []
      }
      this.onSearch()
      if(this.$refs?.refVersion) this.$refs.refVersion.handleSearch("") // 重置重新查询版本下拉
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      if (!this.queryParams?.organizationCodeListNew || this.queryParams?.organizationCodeListNew?.length < 1) {
        const arr = []
        this.inventOrg.forEach(element => {
          arr.push(element.realValue)
        });
        this.queryParams.organizationCodeList = arr
      } else {
        this.queryParams.organizationCodeList = this.queryParams.organizationCodeListNew
      }
      const obj = JSON.parse(JSON.stringify(this.queryParams))
      obj.staDemandDate = obj.demandDate && obj.demandDate[0] || ""
      obj.endDemandDate = obj.demandDate && obj.demandDate[1] || ""
      handleCopyFromExcel('callDocNumber', 'callDocNumberList', obj) // 物料编码支持excel的copy查询
      handleCopyFromExcel('wipEntityName', 'wipEntityNameList', obj)
      delete obj.demandDate
      delete obj.createTimeList
      this.$refs.download.openModal(obj)
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.queryParams = JSON.parse(element.schemeDetailJson)
              this.onSearch()
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    statusOnChange () {
      this.$set(this.queryParams, 'switchFlg', this.queryParams.switchFlg === 'Y' ? 'N' : 'Y')
    }
  }
}
</script>

<style scoped lang="less">
.plan-time{
  font-weight: bold;
}
/deep/.ant-select-selection__choice{
  width: 66.47px;
}
/deep/.ant-calendar-picker{
  width: 100% !important
}
/deep/.ant-form-item-control-wrapper{
  width: 25% !important
}
/deep/.ant-drawer-content-wrapper{
  .ant-form-item{
    .ant-form-item-control-wrapper{
      width: 83.33% !important
    }
  }
}
.display-none {
  display: none
}
</style>
